import { useRef, useEffect, useState } from 'react';
import './MenuContainer.css';
import { useAtomValue } from 'jotai';
import { isSeparateDisplayControllerAtom, selectedMapIdAtom } from '../../atoms';
import { MenuItemProps } from '../../types/components/menuItem';
import { toggleSelectedLayers } from '../../lib/selectedLayersControl';
import classNames from 'classnames';
import { MAIN_MAP_ID } from '../../constants/components/map';
import ReactGA from 'react-ga4';
import { BsExclamationOctagonFill } from 'react-icons/bs';
import { DataType } from '../../types/lib/types';


const MenuItem = ({ id, label, isAlert, item, selectedLayers, setSelectedLayers }: MenuItemProps) => {

  const checkboxRefData = useRef<HTMLInputElement>(null);
  const labelRef = useRef<HTMLLabelElement>(null);

  const selectedMapId = useAtomValue(selectedMapIdAtom);
  const isSeparateDisplay = useAtomValue(isSeparateDisplayControllerAtom);

  const [tooltipPosition, setTooltipPosition] = useState<{top: number, left: number}>({ top: 0, left: 0 });
  const [isTooltipVisible, setIsTooltipVisible] = useState<boolean>(false);

  const showTooltip = () => {
    if (labelRef.current) {
      const rect = labelRef.current.getBoundingClientRect();
      setTooltipPosition({
        top: rect.bottom + window.scrollY,
        left: rect.left
      });

      setIsTooltipVisible(prev => !prev)
    }
  };

  /* *************
   * checkBoxの初期化
   * *************/
  useEffect(() => {
    if(!checkboxRefData.current || !selectedLayers || !selectedLayers) { return; }
    checkboxRefData.current!.checked = selectedLayers.includes(item.id);

    if(checkboxRefData.current!.checked && selectedMapId === MAIN_MAP_ID) {
      //【GoogleAnalytics】メニューアイテム クリックトラッキング
      ReactGA.event({
        category: "menu_click", // カテゴリ（任意の名前）
        action: "click",          // イベントの種類
        label: `アイテム/${id}`,       // ボタン名
      });
    }

  }, [item, selectedLayers, selectedMapId, id]);

  /* *************
   * アイテム チェックボックス クリック処理
   * *************/ 
  const handleItemCheck = (e: React.ChangeEvent<HTMLInputElement>, checkedItem: string) => {
    if(!selectedLayers) { return; }
    const checked = e.target.checked;
    const newSelectedLayers = toggleSelectedLayers(selectedLayers, [checkedItem], checked);

    setSelectedLayers(newSelectedLayers);
  }

  return (
      <div 
        className={
          classNames(
            "sidebar-item", 
            {
              'red-item': isSeparateDisplay && selectedMapId === MAIN_MAP_ID, 
              'disabled': selectedMapId !== MAIN_MAP_ID && isAlert
            }
          )
        }
        data-layer-id={item.id}
      >
        <label 
          className="label" 
          htmlFor={item.id}
          ref={labelRef}
        >
          <input 
            id={item.id}
            ref={checkboxRefData}
            type="checkbox" 
            onChange={(e) => handleItemCheck(e, item.id)} 
            disabled={(selectedMapId !== MAIN_MAP_ID && isAlert)}
          />
          <span>{label}</span>
          { (item.metadata?.minzoom || item.metadata?.maxzoom || (item as DataType).dataType === 'osm') && 
            <BsExclamationOctagonFill 
              onMouseEnter={showTooltip} 
              onMouseLeave={showTooltip} 
            /> 
          }
        </label>

        {isTooltipVisible &&
          <div className='tooltip' style={{ top: tooltipPosition.top, left: tooltipPosition.left }}>
            { (item as DataType).dataType === 'osm' ? 'ズームレベル13以上で表示されます。施設により表示されるズームレベルが異なります。'
            :
            <>
              ズームレベル
              { item.metadata?.minzoom && 
                  <span className="info">{`${item.metadata.minzoom}以上`}</span> }
              { item.metadata?.maxzoom && 
                  <span className="info">{`${item.metadata.maxzoom}以下`}</span> }
              で表示可能です。
            </>
            }
          </div>
        }
      </div>
  );

};

export default MenuItem;
